import React, {FunctionComponent} from "react";
import {BackgroundColorContext} from "../contexts/BackgroundColorContext";
import {HelpProvider} from "../contexts/HelpContext";
import Report from "../views/Report";
import FooterMini from "../components/Footer/FooterMini";
import GoogleAnalyticsWrapper from "../hooks/GoogleAnalyticsWrapper";
import HelpModal from "../components/Help/HelpModal";

const PublicLayout: FunctionComponent = () => {
  const mainPanelRef = React.useRef(null);

  return (
    <HelpProvider>
      <BackgroundColorContext.Consumer>
        {({color}) => (
          <React.Fragment>
            <div className="wrapper wrapper-full-page">
              <div className="main-panel" ref={mainPanelRef} data-color={color}>
                <GoogleAnalyticsWrapper>
                  <Report isPublic={true} />
                </GoogleAnalyticsWrapper>
                <FooterMini />
              </div>
            </div>
            <HelpModal />
          </React.Fragment>
        )}
      </BackgroundColorContext.Consumer>
    </HelpProvider>
  );
};

export default PublicLayout;
